import RelationshipStatusBadge, {
  optionsForStatus,
} from './RelationshipStatusBadge';
export { optionsForStatus };
export default RelationshipStatusBadge;
